export default __webpack_public_path__ + "static/media/lds-logo_el.ff239b9619ae2b91.svg";